/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineClassModules200,
  GetApiV1ClassroomdisciplineClassModules401,
  GetApiV1ClassroomdisciplineClassModules500,
  GetApiV1ClassroomdisciplineClassModulesQueryParams,
  GetApiV1ClassroomdisciplineClassModulesQueryResponse,
} from "../../types/classPlanningClassModuleController/GetApiV1ClassroomdisciplineClassModules.ts";
import { classModuleListItemViewModelSchema } from "../classModuleListItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineClassModulesQueryParamsSchema = z
  .object({
    CompanyId: z.optional(z.coerce.number().int()),
    Description: z.optional(z.string()),
    DateStart: z.optional(z.string().datetime()),
    DateFinish: z.optional(z.string().datetime()),
    ClassStudentId: z.optional(z.coerce.number().int()),
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineClassModulesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineClassModules200Schema = z.array(
  z.lazy(() => classModuleListItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineClassModules200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineClassModules401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineClassModules401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineClassModules500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineClassModules500>;

export const getApiV1ClassroomdisciplineClassModulesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineClassModules200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineClassModulesQueryResponse>;
